import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DeconturiVerify from "@/pages/DeconturiVerify";
import AwbStatus from "@/pages/AwbStatus";
import IncasariVerify from "@/pages/IncasariVerify";
import AdminUsers from "@/pages/AdminUsers";
import History from "@/pages/History";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DeconturiVerify />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verificare-rapida"
              element={
                <ProtectedRoute>
                  <DeconturiVerify />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verificare-completa"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/status-awb"
              element={
                <ProtectedRoute>
                  <AwbStatus />
                </ProtectedRoute>
              }
            />
            <Route
              path="/incasari"
              element={
                <ProtectedRoute>
                  <IncasariVerify />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/utilizatori"
              element={
                <ProtectedRoute>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/istoric"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setari"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
